import React, { useState } from "react";
import clsx from "clsx";
import { motion } from "framer-motion";

import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import { StaticImage } from "gatsby-plugin-image";

import HeaderTypography from "../components/v2/Typography/HeaderTypography";
import ParagraphTypography from "../components/v2/Typography/ParagraphTypography";
import WhiteButton from "../components/v2/WhightButton";
import SEO from "../components/SEO";

import useWidth from "../hooks/useWidth";

import { Link } from "gatsby";
import "../styles/index.scss";

import bannerBackground from "../images/v2/case-studies/banner-background.svg";
import caseStudiesBackground from "../images/v2/case-studies/caseStudiesBackground.svg";
import requestDemoBGImg from "../images/v2/case-studies/requestDemo.svg";
import caseStudyHero from "../images/v2/case-studies/CaseStudyHero.png";
import case1 from "../images/v2/case-studies/case-1.webp";
import case2 from "../images/v2/case-studies/case-2.webp";
import case3 from "../images/v2/case-studies/case-3.webp";
import case4 from "../images/v2/case-studies/case-4.webp";
import case5 from "../images/v2/case-studies/case-5.webp";
import case6 from "../images/v2/case-studies/case-6.webp";
import case7 from "../images/v2/case-studies/case-7.webp";
import companyName1 from "../images/v2/case-studies/case-1-name.webp";
import companyName2 from "../images/v2/case-studies/case-2-name.webp";
import companyName3 from "../images/v2/case-studies/case-3-name.webp";
import companyName4 from "../images/v2/case-studies/case-4-name.webp";
import companyName5 from "../images/v2/case-studies/case-5-name.webp";
import companyName6 from "../images/v2/case-studies/case-6-name.webp";
import companyName8 from "../images/v2/case-studies/case-8-name.webp";

const useStyles = makeStyles((theme) => ({
   img: {
      maxWidth: "100%",
      height: "auto",
   },
   bannerBackground: {
      background: `url(${bannerBackground}) left center no-repeat`,
      backgroundSize: "cover",
   },
   caseStudiesBackground: {
      background: `url(${caseStudiesBackground}) left center no-repeat`,
      backgroundSize: "cover",
   },
   requestDemoRoot: {
      background:
         "transparent linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
      backgroundSize: "cover",
      paddingTop: "65px",
      paddingBottom: "65px",
      "@media(max-width:1024px)": {
         padding: "65px 15px",
      },
      "@media(max-width:600px)": {
         padding: "40px 15px",
      },
   },

   requestDemoHeading: {
      fontSize: "56px",
      fontWeight: 600,
      lineHeight: 1.2,
      marginBottom: "48px",
      marginTop: 0,
      "@media(max-width:1200px)": {
         fontSize: "48px",
      },
      "@media(max-width:992px)": {
         fontSize: "40px",
      },
      "@media(max-width:600px)": {
         fontSize: "32px",
         marginBottom: "32px",
      },
   },
   readMoreLink: {
      color: "#ff7a59",
      textDecoration: "underline",
      fontSize: "16px",
      padding: "16px 8px",
   },
   getStartedBtn: {
      display: "flex",
      alignItems: "center",
      [theme.breakpoints.down("sm")]: {
         justifyContent: "center",
      },
   },
   accordionTitle: {
      [theme.breakpoints.down("sm")]: {
         justifyContent: "center",
      },
   },

   // Hero section
   heroBg: {
      background:
         "radial-gradient(circle at 22% 95%, rgba(158, 90, 213, 0.25) 0%, transparent 22%), radial-gradient(circle at 100% 0%, rgba(158, 90, 213, 0.45) 0%, transparent 30%),radial-gradient(circle at 80% 100%, rgba(32, 142, 236, 0.25) 0%, transparent 22%), #011C33",
      overflow: "hidden",
      paddingTop: "180px",
      paddingBottom: "140px",
      position: "relative",
      "@media(max-width:768px)": {
         paddingTop: "64px",
         paddingBottom: "100px",
      },
   },

   heroCurve: {
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%",
      lineHeight: 0,
      display: "block",
      "& svg": {
         display: "block",
         width: "100%",
         height: "60px",
      },
      "@media(max-width:768px)": {
         "& svg": {
            height: "40px",
         },
      },
      "@media(max-width:425px)": {
         "& svg": {
            height: "30px",
         },
      },
   },

   "@keyframes marqueeScroll": {
      "0%": { transform: "translateX(0)" },
      "100%": { transform: "translateX(-50%)" },
   },

   marqueeWrapper: {
      display: "flex",
      justifyContent: "center",
      marginBottom: "64px",
   },

   marqueePill: {
      border: "1px solid rgba(32, 142, 236, 0.5)",
      borderRadius: "100px",
      padding: "8px 24px",
      overflow: "hidden",
      width: "440px",
      maxWidth: "90vw",
      background:
         "linear-gradient(90deg, rgba(0, 38, 109, 0) 0%, rgba(0, 38, 109, 1) 100%)",
   },

   marqueeTrack: {
      display: "inline-flex",
      alignItems: "center",
      animation: "$marqueeScroll 14s linear infinite",
      whiteSpace: "nowrap",
   },

   industryTag: {
      color: "#51FFCE",
      fontSize: "16px",
      fontFamily: "Inter, sans-serif",
      fontWeight: 500,
      flexShrink: 0,
   },

   industryDot: {
      width: "7px",
      height: "7px",
      minWidth: "7px",
      borderRadius: "50%",
      backgroundColor: "#2DD4BF",
      display: "inline-block",
      margin: "0 20px",
      flexShrink: 0,
   },

   heroHeading: {
      fontSize: "64px",
      fontWeight: 600,
      color: "#fff",
      textAlign: "center",
      marginBottom: "24px",
      marginTop: 0,
      fontFamily: "Inter, sans-serif",
      fontSize: "64px",
      "@media(max-width:1024px)": {
         fontSize: "48px",
      },
      "@media(max-width:600px)": {
         fontSize: "34px",
      },
   },

   heroDesc: {
      fontSize: "20px",
      color: "rgb(255, 255, 255)",
      textAlign: "center",
      maxWidth: "1040px",
      margin: "0 auto 48px auto",
      fontFamily: "Inter, sans-serif",
      fontWeight: 400,
      fontSize: "20px",
      "@media(max-width:1024px)": {
         fontSize: "16px",
      },
   },

   ButtonRound32: {
      borderRadius: "32px !important",
      padding: "12px 44px !important",
      fontSize: "18px !important",
   },

   // Case studies section
   caseStudiesSection: {
      background:
         "radial-gradient(circle at 4% 20%, rgba(255, 163, 101, 0.28) 0%, transparent 18%),radial-gradient(circle at 14% 40%, rgba(159, 211, 255, 0.6) 0%, transparent 20%), radial-gradient(circle at 55% 56%, rgba(218, 172, 255, 0.6) 0%, transparent 20%), radial-gradient(circle at 96% 20%, rgba(0, 154, 153, 0.34) 0%, transparent 18%), radial-gradient(circle at 52% 78%, rgba(159, 211, 255, 0.6) 0%, transparent 20%), #fff",
   },

   caseStudiesSectionHeading: {
      fontSize: "56px",
      fontWeight: 600,
      color: "#010f1d",
      textAlign: "center",
      lineHeight: 1.2,
      fontFamily: "Inter, sans-serif",
      "@media(max-width:1200px)": {
         fontSize: "48px",
      },
      "@media(max-width:992px)": {
         fontSize: "40px",
      },
      "@media(max-width:600px)": {
         fontSize: "32px",
      },
   },

   caseStudiesSubtext: {
      fontSize: "16px",
      color: "#0D1F31",
      textAlign: "center",
      margin: "32px auto 38px auto",
      lineHeight: 1.65,
      fontWeight:500,
      fontFamily: "Inter, sans-serif",
      "@media(max-width:600px)": { fontSize: "15px" },
   },

   filterWrapper: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      gap: "10px",
      maxWidth: "820px",
      margin: "0 auto 56px auto",
   },

   filterBtn: {
      background: "#fff",
      color: "#708093",
      border: "1.5px solid #EDF1F6",
      borderRadius: "100px",
      padding: "8px 20px",
      fontSize: "15px",
      fontFamily: "Inter, sans-serif",
      fontWeight: 400,
      cursor: "pointer",
      transition: "all 0.2s",
      lineHeight: 1.5,
      outline: "none",
      "&:hover": {
         borderColor: "#FF6729",
         color: "#FF6729",
      },
   },

   filterBtnActive: {
      background: "#FF6729 !important",
      color: "#fff !important",
      borderColor: "transparent !important",
      fontWeight: "600 !important",
   },

   staggeredGrid: {
      display: "flex",
      gap: "32px",
      maxWidth: "900px",
      margin: "0 auto",
      alignItems: "flex-start",
      [theme.breakpoints.down("sm")]: {
         gap: "16px",
      },
      [theme.breakpoints.down("xs")]: {
         flexDirection: "column",
         gap: "16px",
      },
   },

   staggeredColLeft: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      gap: "32px",
      minWidth: 0,
      [theme.breakpoints.down("sm")]: {
         gap: "16px",
      },
   },

   staggeredColRight: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      gap: "32px",
      marginTop: "140px",
      minWidth: 0,
      [theme.breakpoints.down("sm")]: {
         gap: "16px",
      },
      [theme.breakpoints.down("xs")]: {
         marginTop: 0,
      },
   },

   caseCard: {
      background: "#fff",
      borderRadius: "16px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      overflow: "hidden",
      display: "block",
      textDecoration: "none",
      transition: "all 0.3s",
      "&:hover, &:hover *": {
         textDecoration: "none",
      },
      "&:hover": {
         boxShadow: "0 8px 20px rgba(159, 211, 255, 0.6)",
         scale: "1.02",
      },
   },

   caseCardImageWrap: {
      position: "relative",
      overflow: "hidden",
   },

   caseCardImg: {
      width: "100%",
      height: "220px",
      objectFit: "cover",
      display: "block",
   },

   caseCardPillsRow: {
      position: "absolute",
      top: "12px",
      left: "12px",
      display: "flex",
      gap: "6px",
   },

   caseCardPill: {
      background: "rgba(255,255,255,1)",
      boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
      borderRadius: "100px",
      padding: "4px 12px",
      fontSize: "12px",
      color: "#010f1d",
      fontWeight: 500,
      lineHeight: 1.5,
   },

   caseCardBody: {
      padding: "20px 20px 16px",
   },

   caseCardLogoWrap: {
      marginBottom: "14px",
      minHeight: "52px",
      display: "flex",
      alignItems: "center",
   },

   caseCardDescription: {
      fontSize: "18px",
      color: "#0D1F31",
      margin: "0 0 14px 0",
      "@media(max-width:600px)": { fontSize: "16px" },
   },
   companyImage:{
    height:'35px'
   }
}));

const CaseStudies = () => {
   const classes = useStyles();
   const width = useWidth();

   const caseStudies = [
      {
         id: 1,
         industry: "Cleaning",
         location: "Singapore",
         image: case1,
         alt: "Pepper Cloud CRM + Eng Choon Enterprise",
         name: (
            <img
               className={classes.companyImage}
               alt="Pepper Cloud CRM + Eng Choon Enterprise"
               placeholder="blurred"
               src={companyName1}
            />
         ),
         description:
            "With WhatsApp-integrated Pepper Cloud CRM, Eng Choon Enterprises is managing its customers’ queries efficiently on various social media platforms.",
         link: "eng-choon-enterprise",
      },
      {
         id: 2,
         industry: "Management services",
         location: "Singapore",
         image: case2,
         alt: "Pepper Cloud CRM + The Supreme HR Advisory",
         name: (
            <img
               className={classes.companyImage}
               alt="Pepper Cloud CRM + The Supreme HR Advisory"
               placeholder="blurred"
               src={companyName2}
            />
         ),
         description:
            "Pepper Cloud CRM is helping The Supreme in organising its sales, boosting its sales productivity, and helping the business grow.",
         link: "cuscapi",
      },
      {
         id: 3,
         industry: "Travel",
         location: "Singapore",
         image: case3,
         alt: "Pepper Cloud CRM + Dreamcation",

         name: (
            <img
               className={classes.companyImage}
               alt="Pepper Cloud CRM + Dreamcation"
               placeholder="blurred"
               src={companyName3}
            />
         ),
         description:
            "Dreamcation, with the help of Pepper Cloud CRM, is improving its response time by replying to its leads and customers quickly.",
         link: "dreamcation",
      },
      {
         id: 4,
         industry: "IT Services",
         location: "Malaysia",
         image: case4,
         alt: "Pepper Cloud CRM + SKYPAC",
         name: (
            <img
               className={classes.companyImage}
               alt="Pepper Cloud CRM + SKYPAC"
               placeholder="blurred"
               src={companyName4}
            />
         ),
         description:
            "Skypac found an easy-to-use, flexible, customisable, and scalable sales solution with Pepper Cloud CRM.",
         link: "tech-data",
      },
      {
         id: 5,
         industry: "Real Estate",
         location: "Toronto, Canada",
         image: case6,
         alt: "Pepper Cloud CRM + Condo Wong",
         name: (
            <img
               className={classes.companyImage}
               alt="Pepper Cloud CRM + Condo Wong"
               placeholder="blurred"
               src={companyName6}
            />
         ),
         description:
            "Condo Wong unifies WhatsApp communication to scale real estate operations.",
         link: "condo-wong",
      },
      {
         id: 6,
         industry: "Recruitment",
         location: "Singapore",
         image: case5,
         alt: "Pepper Cloud CRM + Tech Data",
         name: (
            <img
               className={classes.companyImage}
               alt="Pepper Cloud CRM + Tech Data"
               placeholder="blurred"
               src={companyName5}
            />
         ),
         description:
            "Pepper Cloud CRM is assisting Tech Data in enhancing its productivity through automatic lead capture, customised business modules, and more.",
         link: "the-supreme",
      },
      {
         id: 7,
         industry: "Finance",
         location: "Dubai, UAE",
         image: case7,
         alt: "Pepper Cloud CRM + Cuscapi ",
         name: (
            <img
               className={classes.companyImage}
               alt="Pepper Cloud CRM + Cuscapi "
               placeholder="blurred"
               src={companyName8}
            />
         ),
         description:
            "Mazeed operation upgrade: Centralised communication and smart ticketing",
         link: "mazeede",
      },
   ];

   const marqueeIndustries = [
      "Travel",
      "IT Services",
      "Cleaning",
      "Real Estate",
      "Finance",
      "Recruitment",
      "Management Services",
   ];

   const filterLabels = [
      "All industries",
      "Travel",
      "IT Services",
      "Cleaning",
      "Management services",
      "Recruitment",
      "Real Estate",
      "Finance",
   ];

   const [activeFilter, setActiveFilter] = useState("All industries");

   const filteredStudies =
      activeFilter === "All industries"
         ? caseStudies
         : caseStudies.filter(
              (cs) => cs.industry.toLowerCase() === activeFilter.toLowerCase(),
           );

   const leftCol = filteredStudies.filter((_, i) => i % 2 === 0);
   const rightCol = filteredStudies.filter((_, i) => i % 2 === 1);

   return (
      <React.Fragment>
         <SEO
            canonical="/crm-case-studies/"
            description="Pepper Cloud CRM’s customer journey case studies reveal how many small-medium businesses and enterprises are leveraging CRM software to drive sales growth. Read all case studies."
            keywords="CRM Case Studies,customer journey case study,CRM Case Studies"
            pathname="/crm-case-studies/"
            title="Customer Case Studies | Pepper Cloud CRM"
         />

         {/* Hero Section */}
         <Box className={classes.heroBg}>
            {/* Scrolling industry marquee */}
            <Box className={classes.marqueeWrapper}>
               <Box className={classes.marqueePill}>
                  <Box className={classes.marqueeTrack}>
                     {[...marqueeIndustries, ...marqueeIndustries].map(
                        (industry, i) => (
                           <React.Fragment key={i}>
                              <Box
                                 component="span"
                                 className={classes.industryTag}
                              >
                                 {industry}
                              </Box>
                              <Box className={classes.industryDot} />
                           </React.Fragment>
                        ),
                     )}
                  </Box>
               </Box>
            </Box>

            {/* Heading */}
            <Box px={2}>
               <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                  viewport={{ once: false }}
               >
                  <Box component="h1" className={classes.heroHeading}>
                     Customer{" "}
                     <span
                        style={{
                           background:
                              "linear-gradient(90deg, #B861FF, #FFEBB1)",
                           WebkitBackgroundClip: "text",
                           WebkitTextFillColor: "transparent",
                           backgroundClip: "text",
                        }}
                     >
                        Case Studies
                     </span>
                  </Box>
               </motion.div>

               <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.15 }}
                  viewport={{ once: false }}
               >
                  <Box className={classes.heroDesc}>
                     Learn the success stories of businesses from a variety of
                     industries and how they have boosted their sales growth
                     with Singapore&apos;s #1 sales CRM.
                  </Box>
               </motion.div>

               <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.25 }}
                  viewport={{ once: false }}
               >
                  <Box display="flex" justifyContent="center">
                     <Link
                        to="/crm-testimonials/"
                        style={{ textDecoration: "none" }}
                     >
                        <button
                           className={clsx(
                              classes.ButtonRound32,
                              "primaryButton font-20 colorWhite",
                           )}
                        >
                           Know more
                        </button>
                     </Link>
                  </Box>
               </motion.div>
            </Box>

            {/* Bottom curve divider */}
            <Box className={classes.heroCurve}>
               <svg
                  viewBox="0 0 1440 90"
                  preserveAspectRatio="none"
                  xmlns="http://www.w3.org/2000/svg"
               >
                  <path
                     d="M0,90 Q720,0 1440,90 L1440,90 L0,90 Z"
                     fill="#ffffff"
                  />
               </svg>
            </Box>
         </Box>
         {/* Case Studies Section */}
         <Box className={classes.caseStudiesSection}>
            <Box className="container">
               <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                  viewport={{ once: false }}
               >
                  <Box
                     component="h2"
                     className={classes.caseStudiesSectionHeading}
                  >
                     Businesses success stories
                  </Box>
               </motion.div>

               <Box className={classes.caseStudiesSubtext}>
                  Markets are advancing rapidly and consumers are digitising
                  quickly. The digitalisation of the business and the sales
                  process is cardinal for SMEs. Here are a few stories of our
                  customers on how they adapted to the changing market and
                  embraced unprecedented sales success with Pepper Cloud CRM.
               </Box>

               <Box className={classes.filterWrapper}>
                  {filterLabels.map((label) => (
                     <button
                        key={label}
                        onClick={() => setActiveFilter(label)}
                        className={clsx(
                           classes.filterBtn,
                           activeFilter === label && classes.filterBtnActive,
                        )}
                     >
                        {label}
                     </button>
                  ))}
               </Box>

               <Box className={classes.staggeredGrid}>
                  <Box className={classes.staggeredColLeft}>
                     {leftCol.map((item, i) => (
                        <motion.div
                           key={item.id}
                           initial={{ opacity: 0, y: 30 }}
                           whileInView={{ opacity: 1, y: 0 }}
                           transition={{ duration: 0.4, delay: i * 0.1 }}
                           viewport={{ once: false }}
                        >
                           <Link to={item.link} className={classes.caseCard}>
                              <Box className={classes.caseCardImageWrap}>
                                 <img
                                    src={item.image}
                                    alt={item.alt}
                                    className={classes.caseCardImg}
                                 />
                                 <Box className={classes.caseCardPillsRow}>
                                    <Box
                                       component="span"
                                       className={classes.caseCardPill}
                                    >
                                       {item.industry}
                                    </Box>
                                    <Box
                                       component="span"
                                       className={classes.caseCardPill}
                                    >
                                       {item.location}
                                    </Box>
                                 </Box>
                              </Box>
                              <Box className={classes.caseCardBody}>
                                 <Box className={classes.caseCardLogoWrap}>
                                    {item.name}
                                 </Box>
                                 <p className={classes.caseCardDescription}>
                                    {item.description}
                                 </p>
                              </Box>
                           </Link>
                        </motion.div>
                     ))}
                  </Box>

                  <Box className={classes.staggeredColRight}>
                     {rightCol.map((item, i) => (
                        <motion.div
                           key={item.id}
                           initial={{ opacity: 0, y: 30 }}
                           whileInView={{ opacity: 1, y: 0 }}
                           transition={{ duration: 0.4, delay: i * 0.1 + 0.05 }}
                           viewport={{ once: false }}
                        >
                           <Link to={item.link} className={classes.caseCard}>
                              <Box className={classes.caseCardImageWrap}>
                                 <img
                                    src={item.image}
                                    alt={item.alt}
                                    className={classes.caseCardImg}
                                 />
                                 <Box className={classes.caseCardPillsRow}>
                                    <Box
                                       component="span"
                                       className={classes.caseCardPill}
                                    >
                                       {item.industry}
                                    </Box>
                                    <Box
                                       component="span"
                                       className={classes.caseCardPill}
                                    >
                                       {item.location}
                                    </Box>
                                 </Box>
                              </Box>
                              <Box className={classes.caseCardBody}>
                                 <Box className={classes.caseCardLogoWrap}>
                                    {item.name}
                                 </Box>
                                 <p className={classes.caseCardDescription}>
                                    {item.description}
                                 </p>
                              </Box>
                           </Link>
                        </motion.div>
                     ))}
                  </Box>
               </Box>
            </Box>
         </Box>
         <Box className={classes.requestDemoRoot}>
            <Container>
               <HeaderTypography
                  className={classes.requestDemoHeading}
                  color="common.white"
                  component="h2"
                  textAlign="center"
               >
                 Get started with Pepper Cloud CRM
               </HeaderTypography>
               <Box display="flex" justifyContent="center" mt={2}>
                  <Link to="/contact/" style={{ textDecoration: "none" }}>
                     <button
                        className={clsx(
                           classes.ButtonRound32,
                           "primaryButton font-20 colorWhite"
                        )}
                     >
                        Book a free demo
                     </button>
                  </Link>
               </Box>
            </Container>
         </Box>
      </React.Fragment>
   );
};

export default CaseStudies;
